import { StatusBadge } from '@/components/shared/StatusBadge';
import { storeStatusLabel } from '@/lib/store-status';
import type { StoreOrderStatus } from '../types';

export function StoreOrderStatusBadge({ status, className }: { status: StoreOrderStatus; className?: string }) {
    return <StatusBadge status={status} label={storeStatusLabel(status)} size="md" className={className} />;
}
